var map = {
	"./template.bet575": 1077,
	"./template.bet575.tsx": 1077,
	"./template.bet777": 2131,
	"./template.bet777.tsx": 2131,
	"./template.betstride": 2132,
	"./template.betstride.tsx": 2132,
	"./template.buffalobet": 2133,
	"./template.buffalobet.tsx": 2133,
	"./template.chromabet": 1078,
	"./template.chromabet.tsx": 1078,
	"./template.default": 124,
	"./template.default.tsx": 124,
	"./template.epicodds": 2134,
	"./template.epicodds.tsx": 2134,
	"./template.forsport": 1079,
	"./template.forsport.tsx": 1079,
	"./template.gigabet": 2135,
	"./template.gigabet.tsx": 2135,
	"./template.goldenbet888": 2136,
	"./template.goldenbet888.tsx": 2136,
	"./template.goldenrush": 2137,
	"./template.goldenrush.tsx": 2137,
	"./template.hyperbet": 1080,
	"./template.hyperbet.tsx": 1080,
	"./template.juicybet": 2138,
	"./template.juicybet.tsx": 2138,
	"./template.junglebet": 2139,
	"./template.junglebet.tsx": 2139,
	"./template.magnumbet": 1081,
	"./template.magnumbet.tsx": 1081,
	"./template.oldgill": 1082,
	"./template.oldgill.tsx": 1082,
	"./template.puntcity": 2027,
	"./template.puntcity.tsx": 2027,
	"./template.pyramidbet": 1083,
	"./template.pyramidbet.tsx": 1083,
	"./template.slambet": 2140,
	"./template.slambet.tsx": 2140,
	"./template.sterlingparker": 2141,
	"./template.sterlingparker.tsx": 2141,
	"./template.templebet": 2028,
	"./template.templebet.tsx": 2028,
	"./template.titanbet": 2142,
	"./template.titanbet.tsx": 2142,
	"./template.ts": 966,
	"./template.vikingbet": 2143,
	"./template.vikingbet.tsx": 2143
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2422;